<div class="mainMenuContainer" [class.main-menu-collapsed]="isMenuCollapsed">
  <div class="main-menu-toggle-row">
    <button
      type="button"
      class="main-menu-toggle-btn grBtn"
      (click)="toggleMenuOpen()"
      [attr.aria-label]="isMenuCollapsed ? 'Open sidebar' : 'Close sidebar'"
      [attr.title]="isMenuCollapsed ? 'Open sidebar' : 'Close sidebar'"
    >
      <i class="fa-solid" [class.fa-bars]="isMenuCollapsed" [class.fa-xmark]="!isMenuCollapsed"></i>
    </button>
  </div>

  <div class="main-menu-content">

  <ng-container *ngIf="replicateBetaMenuLinks">
    <!-- Wrap auth in an object so `false` does not hide the whole menu (`*ngIf` treats false as falsy). -->
    <ng-container *ngIf="{ loggedIn: authState$ | async } as beta">
    <a [routerLink]="['/ai/clarichat']" class="logo-link">
      <img class="grid-item-logo gr" src="assets/svg/sosexy.png" alt="" />
    </a>

    <ul class="side-menu-navigation nav flex-column main-menu-beta-accordion-root">
      <ng-container *ngFor="let section of betaMenuSections; trackBy: trackByBetaSection">
        <li
          class="menu-item expandable-item nav-item"
          [class.parent-active]="isRouteInBetaSection(section)"
        >
          <mat-expansion-panel
            [expanded]="isRouteInBetaSection(section)"
            [attr.id]="section.id + 'BetaReplicaPanel'"
          >
            <mat-expansion-panel-header
              class="menu-link"
              [class.parent-active-header]="isRouteInBetaSection(section)"
            >
              <div class="item-header-content slammedleft">
                <mat-panel-title>
                  <span
                    *ngIf="section.id === 'instruments' && section.iconSrc"
                    class="menusvg beta-menu-rail-icon beta-menu-rail-icon--guitar"
                    [ngStyle]="{
                      '-webkit-mask-image': 'url(' + section.iconSrc + ')',
                      'mask-image': 'url(' + section.iconSrc + ')'
                    }"
                    role="img"
                    [attr.aria-label]="section.iconAlt || ''"
                  ></span>
                  <img
                    *ngIf="section.id !== 'instruments' && section.iconSrc"
                    class="fa-message menusvg"
                    [src]="section.iconSrc"
                    [alt]="section.iconAlt || ''"
                  />
                  <i *ngIf="section.iconClass" [class]="section.iconClass" aria-hidden="true"></i>
                  <div>
                    <span class="menu-item-title-conversation">{{ section.title }}</span>
                    <span class="menu-item-subtitle-beta">{{ section.subtitle }}</span>
                  </div>
                </mat-panel-title>
              </div>
            </mat-expansion-panel-header>

            <ul class="menu-sub-navigation nav flex-column">
              <li
                class="menu-item nav-item"
                *ngFor="let link of section.links; trackBy: trackByBetaLink"
              >
                <a
                  class="menu-link nav-link"
                  [routerLink]="[link.route]"
                  routerLinkActive="active"
                  (click)="onBetaReplicaAuthClick($event, link)"
                >
                  <span class="menu-item-title">
                    <i *ngIf="link.iconClass" [class]="link.iconClass" aria-hidden="true"></i>
                    {{
                      link.label === 'Log In'
                        ? (beta.loggedIn ? 'Logout' : 'Log In')
                        : link.label
                    }}
                  </span>
                </a>
              </li>

              <ng-container *ngIf="section.id === 'chat'">
                <li
                  class="menu-item nav-item conversation-history-header"
                  *ngIf="beta.loggedIn && recentConversations.length > 0"
                >
                  <div class="conversation-history-divider"></div>
                  <div class="conversation-history-title">Your Chats</div>
                </li>

                <li
                  class="menu-item nav-item conversation-item"
                  *ngFor="let conv of recentConversations; trackBy: trackByConversationId"
                  (mouseenter)="hoveredConversationId = conv.id"
                  (mouseleave)="hoveredConversationId = null"
                >
                  <a
                    class="menu-link nav-link conversation-link"
                    *ngIf="editingTopicId !== conv.id"
                    [routerLink]="['/ai/clarichat']"
                    (click)="!editingTopicId && loadConversationBetaReplica(conv.id)"
                  >
                    <div class="conversation-content">
                      <div class="conversation-topic-wrapper">
                        <i class="fa fa-message fa-message-ali" aria-hidden="true"
                          >&nbsp;{{ conv.messages?.length || 0 }}&nbsp;</i
                        >
                        <span
                          class="conversation-topic"
                          [title]="conv.topic || 'Conversation'"
                        >
                          {{ truncateTopicBetaReplica(conv.topic || 'Classified Chat') }}
                        </span>
                        <button
                          class="conversation-edit-btn"
                          *ngIf="!editingTopicId"
                          (click)="startEditingTopic(conv.id, conv.topic || ''); $event.stopPropagation()"
                          type="button"
                          aria-label="Edit topic"
                        >
                          <i class="fa-regular fa-pen-to-square"></i>
                        </button>
                      </div>
                    </div>
                  </a>

                  <div class="conversation-edit-mode" *ngIf="editingTopicId === conv.id">
                    <input
                      type="text"
                      class="conversation-topic-input"
                      [(ngModel)]="editingTopicValue"
                      (keydown.enter)="saveTopic(conv.id)"
                      (keydown.escape)="cancelEditingTopic()"
                      (blur)="saveTopic(conv.id)"
                      maxlength="60"
                      placeholder="Enter topic..."
                    />
                    <div class="conversation-edit-actions">
                      <button
                        class="conversation-save-btn"
                        (click)="saveTopic(conv.id)"
                        type="button"
                        aria-label="Save"
                      >
                        <i class="fa-solid fa-check"></i>
                      </button>
                      <button
                        class="conversation-cancel-btn"
                        (click)="cancelEditingTopic()"
                        type="button"
                        aria-label="Cancel"
                      >
                        <i class="fa-solid fa-xmark"></i>
                      </button>
                    </div>
                  </div>
                </li>

                <li class="menu-item nav-item" *ngIf="beta.loggedIn && loadingConversations">
                  <div class="conversation-loading">Loading conversations...</div>
                </li>
              </ng-container>
            </ul>
          </mat-expansion-panel>
        </li>
      </ng-container>
    </ul>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!replicateBetaMenuLinks">
  <a [routerLink]="['/clarichat']" class="logo-link">
    <img class="grid-item-logo" src="assets/svg/sosexy.png" />
  </a>

  <ul class="side-menu-navigation nav flex-column">
    <li class="menu-item expandable-item nav-item"
    [class.parent-active]="isRouteInSection('chat')">

  <mat-expansion-panel
    [expanded]="isRouteInSection('chat')"
    id="conversationsHeader">

    <mat-expansion-panel-header
      class="menu-link"
      [class.parent-active-header]="isRouteInSection('chat')">

          <div class="item-header-content slammedleft">
            <mat-panel-title>
              <i class="fa-solid fa-atom atomali"></i> 
        <i class="fa-regular fa-message"></i>
                <img class="fa-message menusvg" src="assets/last-chat.svg" />
              <div>
                <span class="menu-item-title-conversation">Chat Labs</span>
                <span class="menu-item-subtitle-main"># of AI</span>
              </div>
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>

        <ul class="menu-sub-navigation nav flex-column">
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              id="newChatLink"
              class="menu-link nav-link new-chat-link"
              [routerLinkActive]="['active']"
              [routerLink]="['/clarichat']"
              (click)="startNewChat()"
            >
              <span class="menu-item-title">New Chat<i class="fa-solid fa-plus kim-double-fisted "></i></span>
            </a>
          </li>
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              id="executiveChatLink"
              class="menu-link nav-link"
              [routerLinkActive]="['active']"
              [routerLink]="['/multi-ai/executive-chat']"
            >
              <span class="menu-item-title">ExecutiveChat<img src="assets/exec.svg" class="reverse-kim-cowgirl"></span>
            </a>
          </li>

          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              id="clariChatLink"
              class="menu-link nav-link"
              [routerLinkActive]="['active']"
              [routerLink]="['/ai/clarity']"
            >

              <span class="menu-item-title">ClariChat<img class="reverse-kim-cowgirl"  src="assets/svg/sosexy.png"></span>
            </a>
          </li>

          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              id="compareLink"
              class="menu-link nav-link"
              [routerLinkActive]="['active']"
              [routerLink]="['/ai/compare-mode']"
            >
              <span class="menu-item-title">Compare <sup class="poly-sup">2</sup> </span>
            </a>
          </li>

     
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              id="clariChatLink"
              class="menu-link nav-link"
              [routerLinkActive]="['active']"
              [routerLink]="['/library/calendar']"
            >
              <span class="menu-item-title">Calendar&nbsp; <i class="fa-solid fa-calendar reverse-kim-cowgirl"></i></span>
            </a>
          </li>

          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              id="clariChatLink"
              class="menu-link nav-link"
              [routerLinkActive]="['active']"
              [routerLink]="['/library/search']"
            >
            <span class="menu-item-title"> 
            <b class="kimdoggy">Search</b></span>
            </a>
          </li>
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              id="instantMessageLink"
              class="menu-link nav-link"
              [routerLinkActive]="['active']"
              [routerLink]="['/multi-ai/executive-chat']"
            >
              <span class="menu-item-title">IM&nbsp;<i class="fa-regular fa-paper-plane"></i></span>
            </a>
          </li>
        </ul>
      </mat-expansion-panel>
    </li>

    <li class="menu-item expandable-item nav-item"
    [class.parent-active]="isRouteInSection('create')">

  <mat-expansion-panel
    [expanded]="isRouteInSection('create')"
    id="libraryHeader">

    <mat-expansion-panel-header
      class="menu-link"
      [class.parent-active-header]="isRouteInSection('create')">

          <div class="item-header-content">
            <mat-panel-title>

              <img src="assets/svg/slanted-guitar.svg"  height="40px" class="menusvg" />

              <div>
                <span class="menu-item-title-personality mm">Creative</span>
                <span class="menu-item-subtitle-main">Visionary</span>
              </div>
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>

        <ul class="menu-sub-navigation nav flex-column">

          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/ai/studio']">
              <span class="menu-item-title">Studio</span>
            </a>
          </li>
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/copy']">
              <span class="menu-item-title">Copy</span>
            </a>
          </li>
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/notes']">
              <span class="menu-item-title">Note</span>
            </a>
          </li>

          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/scrum-board']">
              <span class="menu-item-title">Project</span>
            </a>
          </li>

          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/ai/code']">
              <span class="menu-item-title">Coding</span>
            </a>
          </li>

          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/ai/dashboard']">
              <span class="menu-item-title">
                <i class="fa-solid fa-gauge" aria-hidden="true"></i>&nbsp;Dashboard
              </span>
            </a>
          </li>
    
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/media-library']">
              <span class="menu-item-title">Library</span>
            </a>
          </li>
      
      
        </ul>
      </mat-expansion-panel>
    </li>

    <li class="menu-item expandable-item nav-item"
    [class.parent-active]="isRouteInSection('focus')">

  <mat-expansion-panel
    [expanded]="isRouteInSection('focus')"
    id="gptsHeader">

    <mat-expansion-panel-header
      class="menu-link"
      [class.parent-active-header]="isRouteInSection('focus')">


          <div class="item-header-content">
            <mat-panel-title>
              <img src="assets/svg/media-library.svg" height="32px" class="menusvg" />
              <div>
                <span class="menu-item-title-personality mm2">Instruments</span>
                <span class="menu-item-subtitle-main">Categorize</span>
              </div>
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>
        <ul class="menu-sub-navigation nav flex-column">
               <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              id="imageEditLink"
              class="menu-link nav-link"
              [routerLinkActive]="['active']"
              [routerLink]="['/library/image-edit']"
            >
              <span class="menu-item-title">ImageNinja</span>
            </a>
          </li>

       

          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/multi-ai/iq']">
              <span class="menu-item-title">IQ</span>
            </a>
          </li>

          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/multi-ai/personality']">
              <span class="menu-item-title">Personality</span>
            </a>
          </li>

          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/studio-plus']">
              <span class="menu-item-title">Studio+Plus</span>
            </a>
          </li>
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLinkActive]="['active']" [routerLink]="['/iq/media-library']">
              <span class="menu-item-title">Library</span>
            </a>
          </li>
        </ul>
      </mat-expansion-panel>
    </li>

    <li class="menu-item expandable-item nav-item"
    [class.parent-active]="isRouteInSection('account')">

  <mat-expansion-panel
    [expanded]="isRouteInSection('account')"
    id="settingsHeader">

    <mat-expansion-panel-header
      class="menu-link"
      [class.parent-active-header]="isRouteInSection('account')">

          <div class="item-header-content">
            <mat-panel-title>
              &nbsp;
              <i class="fas fa-wrench alicustom"></i>
              <span class="menu-item-title-settings">&nbsp;Account</span>
            </mat-panel-title>
          </div>
        </mat-expansion-panel-header>

        <ul class="menu-sub-navigation nav flex-column">
  
          <li class="menu-item nav-item" *ngIf="isLoggedIn && currentUser">
            <div class="menu-link nav-link user-info-display">
              <span class="menu-item-title" *ngIf="currentUser.firstName || currentUser.lastName">
                {{ (currentUser.firstName || '') + ' ' + (currentUser.lastName || '') }}
              </span>
              <span class="menu-item-title" *ngIf="!currentUser.firstName && !currentUser.lastName && currentUser.email">
                {{ currentUser.email }}
              </span>
              <span class="menu-item-title" *ngIf="!currentUser.firstName && !currentUser.lastName && !currentUser.email">
                Guest
              </span>
            </div>
          </li>
   <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a
              id="friendsImLink"
              class="menu-link nav-link"
              [routerLinkActive]="['active']"
              [routerLink]="['/iq/friends']"
            >
              <span class="menu-item-title">Friends &amp; IM&nbsp;<i class="fa-solid fa-user-group"></i></span>
            </a>
          </li>
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLink]="['/auth/preferences']">
              <span class="menu-item-title">Options</span>
            </a>
          </li>
          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" [routerLink]="['/iq/integrations/kayak']">
              <span class="menu-item-title">Integrations</span>
            </a>
          </li>

          <li class="menu-item nav-item" [routerLinkActive]="['active']">
            <a class="menu-link nav-link" *ngIf="isLoggedIn" (click)="logout()">
              <span class="menu-item-title">Logout</span>
            </a>
            <a class="menu-link nav-link" *ngIf="!isLoggedIn" [routerLink]="['/auth/log-in']">
              <span class="menu-item-title">Log In</span>
            </a>
          </li>
        </ul>
      </mat-expansion-panel>
    </li>
              
              <li class="menu-item nav-item conversation-history-header" *ngIf="isLoggedIn && recentConversations.length > 0">
                <div class="conversation-history-divider"></div>
                <div class="conversation-history-title">Conversations</div>
              </li>
    
              <li 
                class="menu-item nav-item conversation-item" 
                *ngFor="let conv of recentConversations; trackBy: trackByConversationId"
                (click)="!editingTopicId && loadConversation(conv.id)"
                (mouseenter)="hoveredConversationId = conv.id"
                (mouseleave)="hoveredConversationId = null"
              >
                <a class="menu-link nav-link conversation-link" [routerLink]="['/clarichat']" *ngIf="editingTopicId !== conv.id">
                  <div class="conversation-content">
                    <div class="conversation-topic-wrapper">
                      <span class="conversation-topic" [title]="conv.topic || 'Conversation'">
                        {{ truncateTopic(conv.topic || 'Conversation') }}
                      </span>
                      <button 
                        class="conversation-edit-btn"
                        *ngIf="!editingTopicId"
                        (click)="startEditingTopic(conv.id, conv.topic || ''); $event.stopPropagation()"
                        type="button"
                        aria-label="Edit topic"
                      >
                        <i class="fa-regular fa-pen-to-square"></i>
                      </button>
                    </div>
                    <div class="conversation-meta">
                      <span class="conversation-date">{{ formatDate(conv.updatedAt) }}</span> 
                      <span class="conversation-count" *ngIf="conv.messages?.length">
                        <i class="fa-solid fa-message"></i>
                        {{ conv.messages.length }} {{ conv.messages.length === 1 ? 'message' : 'messages' }}
                      </span>
                    </div>
                  </div>
                </a>
                
              
                <div class="conversation-edit-mode" *ngIf="editingTopicId === conv.id">
                  <input
                    type="text"
                    class="conversation-topic-input"
                    [(ngModel)]="editingTopicValue"
                    (keydown.enter)="saveTopic(conv.id)"
                    (keydown.escape)="cancelEditingTopic()"
                    (blur)="saveTopic(conv.id)"
                    #topicInput
                    maxlength="60"
                    placeholder="Enter topic..."
                  />
                  <div class="conversation-edit-actions">
                    <button 
                      class="conversation-save-btn"
                      (click)="saveTopic(conv.id)"
                      type="button"
                      aria-label="Save"
                    >
                      <i class="fa-solid fa-check"></i>
                    </button>
                    <button 
                      class="conversation-cancel-btn"
                      (click)="cancelEditingTopic()"
                      type="button"
                      aria-label="Cancel"
                    >
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                </div>
              </li>
    
              <li class="menu-item nav-item" *ngIf="isLoggedIn && loadingConversations">
                <div class="conversation-loading">Loading conversations...</div>
              </li>
  </ul>
  </ng-container>
  </div>
</div>  
